// extracted by mini-css-extract-plugin
module.exports = {"p404":"Page404_p404__1Sdch","logo":"Page404_logo__Cuy6I","caption":"Page404_caption__1x7Gx","link":"Page404_link__3KnbX","page404__dark":"Page404_page404__dark__2HHTB"};